import React from 'react';

import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';

import { InbodyIndicatorInfo } from '../../../../../../interfaces/inbodyIndicator';
import { getRoundedNumber } from '../../../../../../../shared/utils/mathUtils';
import { INBODY_INDICATORS_KEY } from '../../../../../../constants/inbodyIndecatorsKey';
import { MealPlanOnScanDayInfo } from '../../../../../../interfaces/mealPlanOnScanDayInfo';
import { InbodyType } from '../../../../../../../shared/constants/inbody-info/InbodyType';
import { Flags } from '../../../../../../../utils-types';
import { WidgetEmptyPlaceholder } from '../../../../../../../shared/components/ui-components';
import { getDataLabels } from './utils/getDataLabels';
import { ShortListChart } from './ShortListChart/ShortListChart';
import { LongListChart } from './LongListChart/LongListChart';

type IndicatorChartProps = {
  indicator: InbodyIndicatorInfo;
  mealPlansOnScanDay: MealPlanOnScanDayInfo[];
  customerInbodyTypeFlags: Flags<InbodyType>;
  shortListLimit: number;
};

const CHART_HEIGHT = 240;
const WEIGHT_CHART_HEIGHT = 298;

const IndicatorChart = ({
  indicator,
  mealPlansOnScanDay,
  customerInbodyTypeFlags,
  shortListLimit,
}: IndicatorChartProps) => {
  const { key, scans } = indicator;

  if (!scans?.length) {
    return (
      <div style={{ minHeight: CHART_HEIGHT, display: 'flex' }}>
        <WidgetEmptyPlaceholder
          title="No data available"
          icon={<BarChartRoundedIcon />}
          text="Compatible with: 380, 580, 770, 970"
        />
      </div>
    );
  }

  const labels = getDataLabels({
    scans,
    indicatorKey: key,
    mealPlansOnScanDay,
    customerInbodyTypeFlags,
  });

  const values = scans.map(({ value }) => {
    if (key === INBODY_INDICATORS_KEY.ECW_TBW) {
      return value;
    }

    return getRoundedNumber(value, 1);
  });

  const chartHeight =
    key === INBODY_INDICATORS_KEY.WEIGHT && mealPlansOnScanDay.length > 0
      ? WEIGHT_CHART_HEIGHT
      : CHART_HEIGHT;

  return (
    <div style={{ height: chartHeight }}>
      {scans.length > shortListLimit ? (
        <LongListChart labels={labels} values={values} />
      ) : (
        <ShortListChart labels={labels} values={values} />
      )}
    </div>
  );
};

export { IndicatorChart };
